
export default {
  SET_VESSELS(state, data) {
    state.vessels = data;
  },
  SET_PAGING(state, data) {
    state.pageable = data;
  },
  SET_COUNTRY_CODE(state, data) {
    state.countryCodes = data;
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
}
